import { CountryDropdownButton, Dropdown, CountryDropdownItem } from "@similarweb/ui-components";

import { DD_WIDTH } from "app/pages/sales-intelligence/modules/enrichment/constants/constants";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { ICountryObject } from "app/services/CountryService";

import { StyledCountryDropdownButton } from "./style";

type AllowedCountriesDropdownProps = {
    onCountrySelect(country: ICountryObject): void;
    selectedCountry: ICountryObject;
    dataAutomation: string;
    appendTo?: string;
    width?: number;
    hasSearch?: boolean;
    dropdownPopupHeight?: number;
};

export const AllowedCountriesDropdown = ({
    onCountrySelect,
    selectedCountry,
    dataAutomation,
    width = DD_WIDTH,
    appendTo,
    hasSearch,
    dropdownPopupHeight,
}: AllowedCountriesDropdownProps) => {
    const countries = salesSettingsHelper.getAllowedCountries();

    const countriesOption = [
        <CountryDropdownButton
            width={width}
            key={selectedCountry?.text}
            countryId={selectedCountry?.id}
            data-automation={dataAutomation}
        >
            <StyledCountryDropdownButton>{selectedCountry?.text}</StyledCountryDropdownButton>
        </CountryDropdownButton>,
        ...countries.map(({ id, text }) => {
            return (
                <CountryDropdownItem
                    key={id}
                    id={id}
                    text={text}
                />
            );
        }),
    ];

    return (
        <Dropdown
            appendTo={appendTo}
            selectedIds={{ [selectedCountry?.id]: true }}
            onClick={onCountrySelect}
            width={width}
            dropdownPopupPlacement="ontop-left"
            hasSearch={hasSearch}
            dropdownPopupHeight={dropdownPopupHeight}
        >
            {...countriesOption}
        </Dropdown>
    );
};
